import type { InventoryTransaction } from '../types/inventoryTransaction';

export const inventoryMovementRowKey = (row: InventoryTransaction): string =>
  `${row.movement_type}-${row.id}`;

const parseNum = (value: string) => {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
};

const parseQty = (value: string | null | undefined) => {
  if (value == null || value === '') return 0;
  return parseNum(value);
};

const receiptHasBackorderSplit = (row: InventoryTransaction) =>
  row.movement_type === 'RECEIPT' && parseQty(row.qty_applied_to_backorder) > 0;

export interface InventoryMovementTotals {
  count: number;
  qtyChange: number;
  valueChange: number;
  qtyAddedToStock: number;
  hasReceiptBackorderSplit: boolean;
}

export const computeInventoryMovementTotals = (
  rows: InventoryTransaction[]
): InventoryMovementTotals => {
  let qtyChange = 0;
  let valueChange = 0;
  let qtyAddedToStock = 0;
  let hasReceiptBackorderSplit = false;
  for (const row of rows) {
    qtyChange += parseNum(row.qty_change);
    valueChange += parseNum(row.value_change);
    if (receiptHasBackorderSplit(row)) {
      hasReceiptBackorderSplit = true;
      qtyAddedToStock += parseQty(row.qty_added_to_stock);
    }
  }
  return {
    count: rows.length,
    qtyChange,
    valueChange,
    qtyAddedToStock,
    hasReceiptBackorderSplit,
  };
};
